import { render, staticRenderFns } from "./ModalFormRegistrarReversionDetalleSolicitud.vue?vue&type=template&id=1a0522d1&scoped=true"
import script from "./ModalFormRegistrarReversionDetalleSolicitud.vue?vue&type=script&lang=js"
export * from "./ModalFormRegistrarReversionDetalleSolicitud.vue?vue&type=script&lang=js"
import style0 from "./ModalFormRegistrarReversionDetalleSolicitud.vue?vue&type=style&index=0&id=1a0522d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0522d1",
  null
  
)

export default component.exports